//@flow

import styled from "styled-components"

const Location = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  margin: 0 auto;
  flex-shrink: 0;
  flex-basis: 33.3333%;
`

export default Location



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/Location.js